<template>
<div id="app">
    <tab-bar ref="tabbar" @initcanvas="initcanvas" @zoomin="zoomin" @zoomout="zoomout" @pan="pan" @upload="upload" @reset="reset" @back="back" @forward="forward" @opentotalhelp="opentotalhelp" @opennormalhelp="opennormalhelp" @error="error" @redo="redo"></tab-bar>
    <work-space ref="workspace" @firstdraw="$refs.tabbar.drawflag=true" @firstinit="firstinit" @psprocess="psprocess" @hasmark="hasmark" @changebtnstatus="changebtnstatus" @error="error" @reupload="reupload" @initloading="initloading"></work-space>
    <pen-part ref="penpart" @sizechange="sizechange" @penactived="penactived" @tocare="tocare" @opennormalhelp="opennormalhelp" @changeback="changeback"></pen-part>
    <loading v-model="uploadflag">正在上传图片，请稍候...</loading>
    <loading v-model="psflag">正在根据您涂抹图片区域进行抠图，请稍候...</loading>
    <loading v-model="initflag">正在初始化，请稍候...</loading>
    <help ref="help"></help>
    <connectcode/>
</div>
</template>

<script>
import tabBar from './components/TabBar.vue'
import workSpace from './components/WorkSpace.vue'
import penPart from './components/PenPart.vue'
import loading from './components/loading.vue'
import help from './components/dialog/help.vue'
import connectcode from './components/connectcode.vue'
export default {
    name: 'app',
    data() {
        return {
            uploadflag: false,
            psflag: false,
            initflag: false
        }
    },
    components: {
        tabBar,
        workSpace,
        penPart,
        loading,
        help,
        connectcode
    },
    methods: {
        changeback(index){
             this.$refs.workspace.changeback(index)
        },
        redo() {
            this.$refs.penpart.reupload()
            this.initcanvas();
        },
        initloading() {
            this.initflag = !this.initflag
        },
        reupload() {
            this.$refs.tabbar.reupload();
            this.$refs.penpart.reupload()
        },
        error(tips) {
            this.$refs.help.showerror(tips)
        },
        opennormalhelp() {
            this.$refs.help.opennormalhelp()
        },
        opentotalhelp() {
            this.$refs.help.opentotalhelp()
        },
        changebtnstatus(status) {
            this.$refs.tabbar.changebtnstatus(status)
        },
        hasmark(flag) {
            this.$refs.penpart.hasmark(flag)
        },
        tocare() {
            this.$refs.workspace.tocare()
            this.$refs.tabbar.tocare()
        },
        back() {
            this.$refs.workspace.back()
        },
        forward() {
            this.$refs.workspace.forward()
        },
        reset() {
            this.$refs.workspace.reset()
        },
        penactived(type) {
            this.$refs.tabbar.penactived()
            this.$refs.workspace.penactived(type)
        },
        sizechange(size) {
            this.$refs.workspace.sizechange(size)
        },
        upload() {
            this.uploadflag = !this.uploadflag
        },
        psprocess(flag) {
            this.psflag = flag
        },
        pan() {
            this.$refs.workspace.pan()
            this.$refs.penpart.toolactived()
        },
        zoomin() {
            this.$refs.workspace.zoomin()
        },
        zoomout() {
            this.$refs.workspace.zoomout()
        },
        firstinit() {
            this.$refs.tabbar.firstinit()
            this.$refs.penpart.firstinit()
        },
        initcanvas() {
            this.$refs.workspace.initcanvas()
        }
    },
    mounted() {
        //禁止网页缩放
        document.addEventListener('DOMContentLoaded', function (event) {
            // document.body.style.zoom = 'reset';
            document.addEventListener('keydown', function (event) {
                if ((event.ctrlKey === true || event.metaKey === true) &&
                    (event.which === 61 || event.which === 107 ||
                        event.which === 173 || event.which === 109 ||
                        event.which === 187 || event.which === 189)) {
                    event.preventDefault();
                }
            }, false);
            //Chrome,IE9及以上版本
            document.addEventListener('mousewheel', function (event) {
                if (event.ctrlKey === true || event.metaKey) {
                    event.preventDefault();
                }
            }, false);
            //FF
            document.addEventListener('DOMMouseScroll', function (event) {
                if (event.ctrlKey === true || event.metaKey) {
                    event.preventDefault();
                }
            }, false);
        }, false);
    }
}
</script>

<style lang="scss">
@import "./assets/scss/common";
@import "./assets/scss/icon";

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

body {
    margin: 0;
    padding: 0;
    min-width: 1100px;
    background: #eee
}
</style>
